<template>
  <nav class="nav-container">
    <ul class="nav-main">
      <li>
        <router-link v-bind:to="{ name: 'home' }">
          <img class="logo-navbar" src="../images/coloredfinallogochanged.png" alt="Barbershop Talk" preload="auto" />
        </router-link>
      </li>
      <li class="nav-elements">
        <a target="__blank" href="https://barbershoptalk.shop">Barbershop Talk Store</a>
      </li>
      <li class="nav-elements nav-elements--picks">
        <router-link v-bind:to="{ name: 'sniperPicksPage' }">
          <span class="nav-picks-row"><i class="fa fa-crosshairs" aria-hidden="true"></i> Under Sniper</span>
        </router-link>
      </li>
      <li class="nav-elements">
            <router-link  v-bind:to="{ name: 'newsletterPage'}">The Daily Cut</router-link>
          </li>
      <li
        class="nav-elements nav-elements--biz-tech"
        @mouseover="showBizTechDropdown = true"
        @mouseleave="showBizTechDropdown = false"
      >
        <span class="nav-biz-tech-label">Business<br>&amp; Tech<i class="fa fa-light fa-caret-down"></i></span>
        <ul class="dropdown-menu" v-show="showBizTechDropdown">
          <li>
            <router-link class="dropdown-elements-entertainment" v-bind:to="{ name: 'business' }" @click="logBusinessClick">Business</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-entertainment" v-bind:to="{ name: 'technology' }" @click="logTechnologyClick">Technology</router-link>
          </li>
        </ul>
      </li>
      <li class="nav-elements" @mouseover="toggle" @mouseleave="showDropdown = false">
        Sports<i class="fa fa-light fa-caret-down"></i>
        <ul class="dropdown-menu" v-show="showDropdown">
          <li>
            <router-link class="dropdown-elements-sports dropdown-elements-sports--wide" v-bind:to="{ name: 'yourSports' }">Your Sports</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-sports" v-bind:to="{ name: 'nba' }" @click="logNbaClick">NBA</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-sports" v-bind:to="{ name: 'nfl' }" @click="logNflClick">NFL</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-sports" v-bind:to="{ name: 'nhl' }" @click="logNhlClick">NHL</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-sports" v-bind:to="{ name: 'mma' }" @click="logMmaClick">MMA</router-link>
          </li>
        </ul>
      </li>
      <li class="nav-elements" @mouseover="toggle" @mouseleave="showDropdown = false">
        Politics<i class="fa fa-light fa-caret-down"></i>
        <ul class="dropdown-menu" v-show="showDropdown">
          <li>
            <router-link class="dropdown-elements-entertainment" v-bind:to="{ name: 'right-wing' }" @click="logRightClick">Right Wing</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-entertainment" v-bind:to="{ name: 'left-wing' }" @click="logLeftClick">Left Wing</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-entertainment" v-bind:to="{ name: 'center' }" @click="logCenterClick">Center</router-link>
          </li>
        </ul>
      </li>
      <li class="nav-elements" @mouseover="toggle" @mouseleave="showDropdown = false">
        Pop Culture<i class="fa fa-light fa-caret-down"></i>
        <ul class="dropdown-menu" v-show="showDropdown">
          <li>
            <router-link class="dropdown-elements-entertainment" v-bind:to="{ name: 'inTheaters' }" @click="logMovieClick">In Theaters</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-entertainment" v-bind:to="{ name: 'movies' }" @click="logMovieClick">Movies</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-entertainment" v-bind:to="{ name: 'television' }" @click="logTvClick">Television</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-entertainment" v-bind:to="{ name: 'music' }" @click="logMusicClick">Music</router-link>
          </li>
        </ul>
      </li>
      <li class="nav-elements">
        <router-link v-bind:to="{ name: 'theCommunity' }">The Barbershop</router-link>
      </li>
      <li class="nav-elements nav-elements--about" @mouseover="showAboutDropdown = true" @mouseleave="showAboutDropdown = false">
        About<i class="fa fa-light fa-caret-down"></i>
        <ul class="dropdown-menu" v-show="showAboutDropdown">
          <li>
            <router-link class="dropdown-elements-about" v-bind:to="{ name: 'aboutPage' }">About Us</router-link>
          </li>
          <li>
            <a
              href="#"
              class="dropdown-elements-about"
              role="button"
              @click.prevent="openExploreTutorial"
            >
              Explore BarbershopTalk
            </a>
          </li>
          <li>
            <router-link class="dropdown-elements-about" v-bind:to="{ name: 'underSniperPage' }">The Under Sniper</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-about" v-bind:to="{ name: 'methodologyPage' }">Methodology</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-about" v-bind:to="{ name: 'howSentimentWorksPage' }">How Sentiment Works</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-about" v-bind:to="{ name: 'howBiasWorksPage' }">How Bias Analysis Works</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-about" v-bind:to="{ name: 'howBlindspotWorksPage' }">How Blindspots Work</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-about" v-bind:to="{ name: 'challengeYourViewPage' }">Challenge Your View</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-about" v-bind:to="{ name: 'editorialPolicyPage' }">Editorial Policy</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-about" v-bind:to="{ name: 'communityGuidelinesPage' }">Community Guidelines</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-about" v-bind:to="{ name: 'privacyPolicyPage' }">Privacy Policy</router-link>
          </li>
          <li>
            <router-link class="dropdown-elements-about" v-bind:to="{ name: 'termsOfServicePage' }">Terms of Service</router-link>
          </li>
        </ul>
      </li>
      <li class="nav-elements" v-show="!token">
        <router-link v-bind:to="{ name: 'login' }">Login</router-link>
      </li>
      <li class="nav-elements" v-show="!token">
        <router-link v-bind:to="{ name: 'register' }">Register</router-link>
      </li>
      <li class="nav-elements" v-show="token">
        <router-link v-bind:to="{ name: 'profilePage' }">Profile</router-link>
      </li>
      <li class="nav-elements" v-show="token">
        <router-link v-bind:to="{ name: 'logout' }">Logout</router-link>
      </li>
      <li>
        <NotificationBell class="nav-bell"></NotificationBell>
      </li>
    </ul>
  </nav>
</template>
<script>

import LoggerService from '@/services/LoggerService';
import ArticleDataService from '@/services/ArticleDataService';
import NotificationBell from '@/components/NotificationBell.vue';
import { replayFromHelp } from '@/composables/useTutorialProgress';

export default {
    name: "navBar",
    components: {
      NotificationBell
    },
    data(){
        return {
            showDropdown: true,
            showAboutDropdown: false,
            showBizTechDropdown: false,
            currentUser: 0
        }
    },
    created(){
        //calls for current user
        ArticleDataService.getUser().then(response => {
          this.currentUser = response.data
    })
    },
    methods:{
        openExploreTutorial(){
            this.showAboutDropdown = false;
            replayFromHelp();
        },
        toggle(){
            this.showDropdown = true;
        },
        logBusinessClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:business`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('business logged')
            } else {
              console.log('not working')
            }
          })
      },
      logTechnologyClick(){
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:technology`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('technology logged')
            } else {
              console.log('not working')
            }
          })
      },
      logNbaClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:nba`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('nba logged')
            } else {
              console.log('not working')
            }
          })
      },
      logNflClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:nfl`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('nfl logged')
            } else {
              console.log('not working')
            }
          })
      },
      logNhlClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:nhl`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('nhl logged')
            } else {
              console.log('not working')
            }
          })
      },
      logMmaClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:mma`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('mma logged')
            } else {
              console.log('not working')
            }
          })
      },
      logPoliticsClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:politics`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('pol logged')
            } else {
              console.log('not working')
            }
          })
      },
      logRightClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:right_wing`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('right logged')
            } else {
              console.log('not working')
            }
          })
      },
      logLeftClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:left_wing`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('left logged')
            } else {
              console.log('not working')
            }
          })
      },
      logCenterClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:left_wing`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('Center logged')
            } else {
              console.log('not working')
            }
          })
      },
      logMovieClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:movies`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('movie logged')
            } else {
              console.log('not working')
            }
          })
      },
      logMusicClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:music`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('music logged')
            } else {
              console.log('not working')
            }
          })
      },
      logTvClick(){
            //log it as an event for the recommender using the event logger
          const event = {
            user_id: this.currentUser,
            articleId: 0,
            event: `category:television`,
            sessionId: this.$store.state.sessionId
          }

          LoggerService.logger(event).then(response => {
            if(response.status == 200){

              console.log('tv logged')
            } else {
              console.log('not working')
            }
          })
      },
        },
        computed: {
          token() {
            return this.$store.state.token;
          }
        }
    }
</script>

<style scoped>
/* HTML TAG ELEMENTS */

img {
    height: 100%;
    width: 27%;
    margin-bottom: 0px;
}

.logo-navbar {
    width: 10rem; 
    flex-shrink: 0;
}

i {
    margin-left: 10px;
    color: #fff;
}

li {
    list-style: none;
    
}

router-link {
    text-decoration: none;
}
/* NAV BAR */

.hamburger-button{
    display: none;
}
.nav-container{
    background: #2a9cff;
    display: flex;
    justify-content: flex-start;
    width: 200vw;
    max-width: 100%;
    height: 8rem;
    border-bottom: 2px solid #dd3434;
    z-index: 1000;
    position: fixed;
    transition: all 0.5s ease;
}
.nav-main{
    display: flex;
    justify-content: center;
    align-items: center;
    margin-left: 0px;
    padding: 0%;
    z-index: 1;  
}
.nav-elements{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-decoration: none;
    padding-top: 50px;
    padding-left: 20px;
    padding-right: 20px;
    flex-grow: 1;
    color: white;
    text-shadow: 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black;
    height: 80%;
    font-family: 'Titillium Web', sans-serif;
    font-weight: 900;
    z-index: 1;
    position: relative;
    -webkit-transition: background-color .5s;
    -moz-transition:    background-color .5s;
    -ms-transition:     background-color .5s;
    -o-transition:      background-color .5s;
    transition:         background-color .5s;
}

.nav-elements a{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-decoration: none;
    flex-grow: 1;
    color: white;
    text-shadow: 0 0 1px black, 0 0 1px black, 0 0 1px black, 0 0 1px black;
    height: 80%;
    font-family: 'Titillium Web', sans-serif;
    font-weight: 900;
    z-index: 1;
    -webkit-transition: background-color .5s;
    -moz-transition:    background-color .5s;
    -ms-transition:     background-color .5s;
    -o-transition:      background-color .5s;
    transition:         background-color .5s;
}
.nav-bell{
    display: flex;
    align-items: center;
    justify-content: center;
    text-align: center;
    text-decoration: none;
    padding-top: 50px;
    padding-left: 20px;
    padding-right: 20px;
    color: white;
    height: 80%;
    font-weight: 900;
    z-index: 1;
    cursor: pointer;
}
.nav-bell:hover{
  color: #dd3434;
}


.nav-elements:hover{
    background-color: #dd3434;
}

.dropdown-menu{
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    text-decoration: none;
    z-index: 100;
    position: absolute;
    top: 100%;
    text-align: left;
    opacity: 0;
    visibility: hidden;
    transition: all 0.5s ease-in-out;
    height: max-content;
    left: 0;
    padding-left: 0;
}

.dropdown-elements-sports{
    margin-top: 0px;
    padding: 10px;
    text-align: center;
    text-decoration: none;
    z-index: 100;
    position: relative;
    width: 148px;
    height: auto;
    min-height: 18px;
    color: white;
    border-top: 0.5px solid white;
    background-color: #dd3434;
    transition: all 0.5s ease-in-out;
    font-size: 22px;
    margin-right: 20px;
    
}

.dropdown-elements-entertainment{
    margin-top: 0px;
    padding: 10px;
    text-align: center;
    text-decoration: none;
    z-index: 100;
    position: relative;
    width: 148px;
    height: 18px;
    color: white;
    border-top: 0.5px solid white;
    background-color: #dd3434;
    transition: all 0.5s ease-in-out;
    font-size: 22px;
}

.dropdown-elements-sports--wide{
    width: 148px;
    font-size: 22px;
    white-space: nowrap;
    height: auto;
    min-height: 18px;
    line-height: 1.15;
}

.dropdown-elements-sports:hover{
    color:rgb(142, 141, 141);
}
.dropdown-elements-entertainment:hover{
    color:rgb(142, 141, 141);
}

.dropdown-elements-about {
    margin-top: 0px;
    padding: 10px 14px;
    text-align: center;
    text-decoration: none;
    z-index: 100;
    position: relative;
    width: 192px;
    height: 18px;
    color: white;
    border-top: 0.5px solid white;
    background-color: #dd3434;
    transition: all 0.5s ease-in-out;
    font-size: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    white-space: nowrap;
}
.dropdown-elements-about:hover {
    color: rgb(142, 141, 141);
}
.dropdown-elements-about:focus-visible {
    outline: 3px solid rgba(255, 255, 255, 0.5);
    outline-offset: -3px;
}

.nav-elements--about .dropdown-menu {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
}

.nav-elements--biz-tech {
    padding-top: 22px;
    padding-left: 12px;
    padding-right: 12px;
    line-height: 1.05;
}
.nav-elements--biz-tech .nav-biz-tech-label {
    display: inline-block;
    text-align: center;
}
.nav-elements--biz-tech .dropdown-menu {
    left: 50%;
    right: auto;
    transform: translateX(-50%);
}

.nav-elements:hover .dropdown-menu {

    transition: all 0.5s ease-in-out;
    opacity: 1;
    visibility: visible;
}

@media (max-width: 1024px) {
  .nav-main{
    font-size: smaller;
  }
  
}

/* Under Sniper flagship nav: established green, no PRO badge */
.nav-elements.nav-elements--picks {
    background: rgba(16, 185, 129, 0.28);
    box-shadow: inset 0 -4px 0 #10b981;
}
.nav-elements.nav-elements--picks:hover {
    background: rgba(16, 185, 129, 0.48);
}
.nav-picks-row {
    display: inline-flex;
    align-items: center;
    gap: 6px;
}
.nav-picks-row i {
    color: #6ee7b7;
}
</style>